import { RouteComponentProps, Router } from "@reach/router"
import { AppWrapper } from "@shared/application-components"
import { Helmet } from "react-helmet"
import metaCardImage from "./assets/MotorPortal-MetaImage.png"
import { AuthProvider } from "./auth/providers"
import { ForgotPassword } from "./auth/ui/ForgotPassword"
import { Login } from "./auth/ui/Login"
import { Unauthorized } from "./auth/ui/Unauthorized"
import { Authenticated } from "./Autheticated"
import { Logout } from "./broker_src/auth/ui/Logout"
import { ClaimSubmissions } from "./pages/ClaimSubmissions"
import { CreateClaimSubmission } from "./pages/CreateClaimSubmission"
import { DriverChecklist } from "./pages/DriverChecklist"
import { PosthogClient } from "./services/posthog"

export const App = () => (
  <AppWrapper>
    <Helmet>
      <meta property="og:image" content={`${window?.location?.origin}${metaCardImage}`} />
      <meta property="twitter:image" content={`${window?.location?.origin}${metaCardImage}`} />
    </Helmet>
    <Router>
      <DriverChecklist path="driver-checklist" />
      <AuthRoutes path="/*" />
    </Router>
  </AppWrapper>
)

const AuthRoutes: React.FC<RouteComponentProps> = () => (
  <AuthProvider>
    <PosthogClient>
      <Router>
        <Login path="login" />
        <Logout path="logout" />
        <ForgotPassword path="reset-password" />
        <Unauthorized path="unauthorized" />
        <ClaimSubmissions path="claim-submissions/:secret" />
        <CreateClaimSubmission path="create-driver-claim-submission" />
        <Authenticated path="/*" />
      </Router>
    </PosthogClient>
  </AuthProvider>
)
